<template>
    <div>
      <div v-if="isLoading" class="loader-overlay">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <div class="container-fluid">
        <div class="llp-container-section heightcontainer">
          <top-header id="height2"></top-header>
          <main-menu id="height3"></main-menu>
          <div class="menu-margin-top">
            <div class="row px-3 ml-0 justify-content-between pt-5">
              <div class="col-lg-1 col-sm-12 mt-2">
                <label class="label">Rename Role</label>
              </div>
              <div class="col-lg-4 col-sm-12 activitySearch mt-2 pl-0">
                <input type="text">
              </div>
              <div class="col-lg-7 activityBtn mt-2" style="text-align: end">
                <button>Save</button>
              </div>
            </div>
            <div class="row tableContainer pb-4 px-3 ml-0 mt-5">
              <div class="col-12">
                <div class="role-form">
      <!-- Loop through permission groups -->
      <div v-for="(group, groupName) in permissions" :key="groupName" class="section">
        <!-- Section header with arrow icon -->
        <div class="row" >
            <div class="row col-11">
                <input  type="checkbox" style="margin-left: 15px;" />
                <h2 >{{ groupName }}</h2>
            </div>
          <span @click="toggleSection(groupName)" class="col-1" :class="{'arrow-up': !group.expanded, 'arrow-down': group.expanded}"></span>
        </div>

        <!-- Content that will collapse/expand -->
        <transition name="slide-fade">
          <div v-if="group.expanded" class="checkbox-group">
            <div v-for="(perm, permName) in group.perms" :key="permName" class="checkbox-item">
              <input type="checkbox" v-model="perm.checked" />
              <label>{{ perm.label }}</label>
            </div>
          </div>
        </transition>
      </div>
    </div>

              </div>
            </div>
          </div>
          <bottom-footer></bottom-footer>
        </div>
      </div>
    </div>
  </template>
  <script>
  import TopHeader from "@/components/TopHeader.vue";
  import MainMenu from "@/components/Menu.vue";
  import BottomFooter from "@/components/BottomFooter.vue";
  import httpcommon from "../js/http-common.js";
  import moment from "moment";
  
  export default {
    components: {
      MainMenu,
      TopHeader,
      BottomFooter,
    },
    name: "addNewRole",
  
    data() {
      return {
        isLoading: false,
        rows: 0,
        currentPage: 1,
        perPage: 10,
        isSearch: false,
        permissions: {
        "Manage Employees": {
          expanded: true,
          perms: {
            "Add Employee": { label: "Add Employee", checked: false },
            "View/Update Employee": { label: "View/Update Employee", checked: true },
          },
        },
        "Manage Customers": {
          expanded: true,
          perms: {
            "Add Customer": { label: "Add Customer", checked: false },
            "View/Update Customer": { label: "View/Update Customer", checked: true },
          },
        },
        "Manage Sources": {
          expanded: true,
          perms: {
            "Add Dealer": { label: "Add Dealer", checked: true },
            "View/Update Dealer": { label: "View/Update Dealer", checked: true },
            "Manage Inhouse": { label: "Manage Inhouse", checked: false },
          },
        },
        "Activity Tracking": {
          expanded: true,
          perms: {
            "Schedule Activity": { label: "Schedule Activity", checked: true },
            "Manage Milege": { label: "Manage Milege", checked: true },
            "Add Task": { label: "Add Task", checked: true },
            "Update Task": { label: "Update Task", checked: true },
            "View Task": { label: "View Task", checked: true },
          },
        },
        "Performance Tracking": {
          expanded: true,
          perms: {
            "View Dashboard": { label: "View Dashboard", checked: true },
            "View Scorecard": { label: "View Scorecard", checked: true },
            "View Assignments": { label: "View Assignments", checked: true },
            "Dashboard Reporting": { label: "Dashboard Reporting", checked: true },
           
          },
        },
        "Deals Tracking": {
          expanded: true,
          perms: {
            "Generate Quote": { label: "Generate Quote", checked: true },
            "Edit Quote": { label: "Edit Quote", checked: true },
            "Add Application": { label: "Add Application", checked: true },
            "Review Application": { label: "Review Application", checked: true },
            "Convert App to Deal": { label: "Convert App to Deal", checked: true },
            "View Deals": { label: "View Deals", checked: true },
            "Yodlee": { label: "Yodlee", checked: true },
            
          },
        },"Reporting": {
          expanded: true,
          perms: {
            "Salesperson Task Notes": { label: "Salesperson Task Notes", checked: true },
            "Report an Issue": { label: "Report an Issue", checked: true },
            "Data Report": { label: "Data Report", checked: true },
            "Automated Quote Tool": { label: "Automated Quote Tool", checked: true },
            "Payoff Quote": { label: "Payoff Quote", checked: true },
            "Customer Audit History": { label: "Customer Audit History", checked: true },
            "Customer Audit History": { label: "Customer Audit History", checked: true },
          },
        },"Customer Universal Search": {
          expanded: true,
          perms: {
          },
        },"DMV Title": {
          expanded: true,
          perms: {
          },
        },"Resource": {
          expanded: true,
          perms: {
            "Release Notes": { label: "Release Notes", checked: true },
            "User Manual": { label: "User Manual", checked: true },
            "Help": { label: "Help", checked: true },
            "Contact": { label: "Contact", checked: true },
           
          },
        },
        "Role Management": {
          expanded: true,
          perms: {
            "Add Role": { label: "Add Role", checked: true },
            "Edit Role": { label: "Edit Role", checked: true },
            "Delete Role": { label: "Delete Role", checked: true },
            "Role Rename": { label: "Role Rename", checked: true },
           
          },
        },
      },
      };
    },
    methods: {

  
      myFunction() {
        var elmnt = document.getElementById("height2");
        var elmnt1 = document.getElementById("height3");
        var txt = elmnt.offsetHeight;
        var width = elmnt.offsetWidth;
        var txt1 = elmnt1.offsetHeight;
        var ht = txt + txt1;
        $("#employee").css("margin-top", txt + txt1 + 3);
      },
      menuheight() {
        var elmnt = document.getElementById("height2");
        var txt = elmnt.offsetHeight;
        $("#height3").css("margin-top", txt);
      },
      toggleSection(sectionName) {
      this.permissions[sectionName].expanded = !this.permissions[sectionName].expanded;
    },
    },
    created() {
      window.addEventListener("resize", this.myFunction);
      window.addEventListener("resize", this.menuheight);
    },
    mounted() {
      this.myFunction();
      this.menuheight();
    },
  };
  </script>
  <style scoped>
  .label {
    color: #6E8399;
    font-weight: 600;
    font-size: 16px;
  }
  .activitySearch input {
  font: 400;
  font-size: 16px;
  color: #1c1b1f;
  border: 1px solid #e4ecf4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
.activityBtn button {
  border-radius: 8px;
  color: #ffffff;
  font-weight: 600;
  font-size: 18px;
  background-color: #1e90ff;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  /* width: 100%; */
}
 .containerA {
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  /* background-color: #f7f7f7; */
}

/* .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
} */

/* input[type="text"] {
  font-size: 16px;
  padding: 5px;
  width: 60%;
} */

/* button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
} */

.role-form {
  column-count: 3;
  column-gap: 16px;
  row-gap: 23px;
}

.section {
    break-inside: avoid; /* Prevent items from breaking between columns */
    padding: 16px; /* Padding for items */
    border: 1px solid #ccc; /* Border for items */
    margin-bottom: 13px;
    border-radius: 8px;
  /* overflow: hidden; */
}

.section-header {
  display: flex;
  /* justify-content: space-around; */
  align-items: center;
  cursor: pointer;
}

h2 {
  font-size: 18px;
}

.arrow-down::before {
  content: "▼";
}

.arrow-up::before {
  content: "▲";
}

.checkbox-group {
  margin-top: 10px;
  /* Control the height dynamically based on content */
  max-height: 400px;
  transition: all 0.3s ease;
  margin-left: 25px;
}

.checkbox-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

input[type="checkbox"] {
  margin-right: 10px;
}

label {
  font-size: 14px;
}

/* Add transitions for smooth collapse/expand */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: max-height 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
 }
</style>